import * as React from "react";
const SvgSubdirectoryRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#000000", width: 240, height: 240, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 13H8V5H6v9a1 1 0 0 0 1 1h7v3l5-4-5-4v3z" }));
export default SvgSubdirectoryRight;
